import { msg } from "@lingui/core/macro";

export const startTimeAfterTimeRuleMessages = {
	name: msg({ message: "Start Time After Time" }),
	description: msg({ message: "Permit Start Time must be after time" }),
	errors: {
		isBefore: msg({ message: "Permit Start Time must be after {time}" }),
	},
} as const;
